import type { CustomerStep, Notice, OfferType, ProgramConfig } from '../types/volunteer';

interface Input {
  step: CustomerStep;
  notice: Notice;
  pageOffer: OfferType;
  config: ProgramConfig;
  discountApplied: boolean;
  claimed: boolean;
}

export function describeCustomerState(s: Input): { code: string; label: string } {
  if (s.step === 'confirmed') {
    return {
      code: '✓',
      label: s.claimed ? 'Checkout complete · reservation converted to claimed' : 'Checkout complete',
    };
  }
  if (s.notice === 'unavailable') return { code: 'H', label: 'Discount gone before a reservation was established' };
  if (s.notice === 'expired' || s.notice === 'expired-unavailable') {
    return { code: 'Exp', label: 'Reservation expired · revalidation required' };
  }
  if (s.discountApplied) return { code: 'F', label: 'Eligible selection · discount reserved and applied to cart' };
  if (s.notice === 'removed') return { code: 'G', label: 'Selection changed · discount removed, cart recalculated' };
  if (s.step === 'cart') return { code: '—', label: 'Cart without volunteer discount' };
  if (s.pageOffer === 'discount') {
    return s.config.coachCreditEnabled
      ? { code: 'D', label: 'Both enabled, capacity left · same treatment as B, Coach Credit suppressed' }
      : { code: 'B', label: 'Volunteer Registration Discount on · capacity available' };
  }
  if (s.pageOffer === 'coachCredit') {
    return s.config.discountEnabled
      ? { code: 'E', label: 'Both on · discount exhausted, only Automated Coach Credit shown' }
      : { code: 'C', label: 'Automated Coach Credit on · discount off' };
  }
  if (s.config.discountEnabled) {
    return { code: 'A', label: 'Discount exhausted, Coach Credit off · standard volunteer experience' };
  }
  return { code: 'A', label: 'Standard volunteer experience · no incentive' };
}
